module.exports = __webpack_public_path__ + "static/media/eyelet02.aecd234b.webp";